import request from "@/utils/request";
import qs from "qs";
export const getCurrentPageHelp = params =>
  request({ url: "/adminPageHelp/current", method: "get", params });
export const explainPageControl = data =>
  request({
    url: "/adminPageHelp/explainControl",
    method: "post",
    data,
    headers: { "Content-Type": "application/json" }
  });
export const getPageHelpList = params =>
  request({ url: "/adminPageHelp/list", method: "get", params });
export const savePageHelp = data => request.post("/adminPageHelp/save", qs.stringify(data));
export const deletePageHelp = params => request.post("/adminPageHelp/delete", qs.stringify(params));
